import { Box, Button, Checkbox, FormControlLabel, IconButton, List, ListItem, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { CPage, CPageTop } from "../components/cr.ui.page";
import { useOrder } from "../components/order";
import { UButton, UListItemButton } from "../common/ui.buttons";
import { GREY, SECONDARY_COLOR } from "../style/theme";
import { CBackButton, CBackToMain } from "../components/cr.ui.buttons";
import { UFooter, ULoading, UMargin, UMarginTop, URow, USection } from "../common/ui.page";
import { createContext, useContext, useEffect, useState } from "react";
import { USkeletonList } from "../common/ui.skeletons";
import { useRest } from "../common/rest";
import { Cancel, Remove } from "@mui/icons-material";
import { Filter, useFilter } from "../common/filter";
import { Search, useSearch } from "../common/search";
import { TextFilterWithClear } from "../components/cr.ui.filter";
import { UnitNew, useUnitNew } from "../components/unit.new";
import { SearchResults } from "../components/cr.ui.search";
import { UnitEdit, useUnitEdit } from "../components/unit.edit";
import { UFieldset } from "../common/ui.fieldset";
import { PageContext } from "../common/pages";
import { CUnitCompText } from "../components/cr.ui.unit";
import { CEditComposition } from "../components/cr.ui.composition";
import { UDialogClose, UDialogCloseOnCompleteButton } from "../common/ui.dialog";
import { UNIT_CATEGORIES } from "../components/unit";

export function PageUnitNew(props) {
    const order = useOrder();

    return <CPage>

        <CBackToMain codex={order.codex.name} />

        <UnitNew>
            <Stack sx={{ background: GREY[200], paddingY: 2 }}>
                <USection>

                    <Typography variant="h6">Aggiungi unità al tuo Ordine di Battaglia</Typography>

                    <UnitSelectionTextFilter />
                    <UnitSelection />
                    <UnitComposition />

                </USection>
            </Stack>

            <UFooter>
                <USection>
                    <UMargin>
                        <ButtonAddUnit />
                    </UMargin>

                </USection>
            </UFooter>

        </UnitNew>

    </CPage>
}

function UnitSelectionTextFilter(props) {
    const unitNew = useUnitNew()

    return <TextFilterWithClear title="Unità" disabled={Boolean(unitNew.unit)} />
}
function UnitSelection(props) {
    const unitNew = useUnitNew()
    const filter = useFilter()
    const search = useSearch()
    const customUnit = {
        name: filter.filter.trim(),
        category: 'Personalizzato',
        pts: 0,
        categories: [],
        composition: { upgrades: [] }
    }

    if (unitNew.unit) {
        return <></>
    }

    const showCustom = customUnit.name.length > 3;

    return <Box sx={{
        maxHeight: 400,
        overflowY: 'scroll',
    }}>
        <SearchResults component={UnitSelectionResult} >
            {showCustom && <UnitSelectionResult
                onClick={() => search.setSelected(customUnit)}
                value={customUnit} />}
        </SearchResults>
    </Box>
}
function UnitSelectionResult(props) {
    const { value } = props;

    return <UListItemButton {...props}>
        <ListItemText primary={value.name} secondary={value.category} />
        <Box>
            <Typography sx={{ fontSize: 12 }}>
                {value.pts}
            </Typography>
        </Box>
    </UListItemButton>
}
function UnitComposition(props) {
    const unitNew = useUnitNew()

    if (!unitNew.unit) {
        return <></>
    }

    return <UnitEdit unit={unitNew.unit}>
        <_UnitComposition />
    </UnitEdit>
}
function _UnitComposition(props) {
    const unitNew = useUnitNew()
    const edit = useUnitEdit()

    useEffect(() => {
        unitNew.updateUnit(edit.unit)
    }, [edit.unit])

    return <Stack spacing={2}>
        <URow>
            <TextField sx={{ width: 100 }} label="Costo" type="number" size="small" {...edit.field('pts')} />
            <Box sx={{ marginLeft: 2, flex: 1 }}>
                <FormControlLabel onClick={() => edit.useModels(!edit.hasModels)} control={<Checkbox checked={Boolean(edit.hasModels)} />} label="Multi modello" />
            </Box>
        </URow>

        <UFieldset title={edit.hasModels ? "Composizione" : "Equipaggiamento"}>
            <CUnitCompText comp={edit.unit.composition} />
            <UMarginTop margin={4}>
                <CEditComposition unit={edit.unit} onChange={edit.updateComposition}
                    button={<UButton fullWidth variant="contained">Modifica</UButton>} />
            </UMarginTop>
        </UFieldset>

        <UnitCategories />
    </Stack>
}
function UnitCategories(props) {
    const edit = useUnitEdit()

    const cats = Object.keys(UNIT_CATEGORIES)

    return <UFieldset title="Tipo">
        <List>
            {cats.map(c => <ListItem sx={{ padding: 0 }} key={c}>
                <FormControlLabel
                    sx={{ width: '100%' }}
                    control={<Checkbox checked={edit.hasCategory(c)} />}
                    onClick={() => edit.setCategory(c, !edit.hasCategory(c))}
                    label={UNIT_CATEGORIES[c]}
                />
            </ListItem>)}
        </List>
    </UFieldset>
}
function ButtonAddUnit(props) {
    const order = useOrder();
    const cmdPage = useContext(PageContext)
    const unitNew = useUnitNew()

    return <UButton
        call={'unit/new'}
        payload={unitNew.unit}
        onCall={() => {
            order.reload();
            cmdPage.setPage(' ');
        }}
        disabled={!Boolean(unitNew.unit)}
        fullWidth
        variant="contained">Aggiungi unità</UButton>
}